// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__qd9Pb","select":"Header_select__28czH","clinic":"Header_clinic__2z57X"};